module.exports = __webpack_public_path__ + "static/expand-7f1b21db6a5fbc43d97242246ec0d83e.png";